import type { CityConfig } from './CityConfig'
import appIconNyc from './assets/app-icon-nyc.png'
import { NYC_LINE_DIAGRAMS } from './nycLineDiagrams'

/**
 * New York — newyork-subway.com, a GTFS city (TASK-1132): online routes come
 * from the server's RAPTOR on the MTA timetable (TASK-1136; a 503 falls back to
 * the offline graph); live station status, line status and arrivals from the
 * MTA feeds (TASK-1271, TASK-1282); a Late Night map (TASK-1136)
 * that turns itself on every night 00:00–06:30; no store app yet, and no web
 * analytics (so no cookie banner).
 */
export const CITY: CityConfig = {
  id: 'nyc',
  apiOrigin: 'https://newyork-subway.com',
  onlineRouting: true,
  stationStatus: true,
  lineStatus: true,
  arrivals: true,
  liveDataSource: 'MTA',
  nightService: true,
  nightWindow: {
    days: [0, 1, 2, 3, 4, 5, 6],
    startMinute: 0,
    durationMinutes: 390,
    autoSwitch: true,
  },
  storeApps: false,
  mapTileCulling: false,
  // Since 2026-11-03: GA4 property "newyork-subway.com" (stream 16265099659);
  // Amplitude project "Metro NYC" (893236), the NYC app's.
  webAnalytics: {
    ga4MeasurementId: 'G-QRCLV116LJ',
    amplitudeApiKey: '474017463a76d9869112cfb53dc2f6c3',
  },
  timeZone: 'America/New_York',
  // New York metro area, the map's reach: Newark (W) to the Rockaways and
  // JFK (E), the Bronx (N) to Staten Island (S).
  homeRegion: { north: 41.0, south: 40.45, east: -73.7, west: -74.3 },
  fallbackPoint: { latitude: 40.6413, longitude: -73.7781 }, // JFK
  airportStationPrefix: 'Terminal',
  launchStationSlug: '57-st-7-av',
  wordmark: 'NYC Subway',
  // AppIcon-NYC (one appearance on iOS, so one for both themes).
  appIcon: { light: appIconNyc, dark: appIconNyc },
  wordmarkLong: 'NYC Subway Map',
  locality: 'New York',
  domain: 'newyork-subway.com',
  serviceName: 'NYC Subway Map',
  mapName: 'New York subway map',
  dataOperator: 'the MTA, PATH, NJ Transit and the other operators',
  lineDiagrams: NYC_LINE_DIAGRAMS,
  // Route names repeat across lines (the 2 and the 3 are both 7 Avenue
  // Express), so a subway line leads with its bullet.
  lineTitles: { lineSuffixTypes: [], shortNameTypes: ['UNDERGROUND'] },
  stationPages: false,
}
